import React from "react";
import PageTitleCard from '../../components/common/PageTitleCard';
import { LucideClipboardList, PlusCircle } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "../../components/ui/tabs";
import { useDispatch } from "react-redux";
import { clearSelectedDeliveryData } from "../../redux/slices/deliverySlice";

const DailyDeliveryPageLayout = ({
  children
}: {
  children: React.ReactNode
}) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = React.useState("todayData");

  const activeTabClassName = "py-2 px-4 rounded-xl cursor-default bg-main-blue text-white font-semibold";
  const tabClassName = "bg-neutral-200 hover:bg-neutral-300/80 text-gray-500 cursor-pointer transition-all ease-in-out duration-300 py-2 px-4 rounded-xl"

  return (
    <div className='relative'>
      <div className="bg-white p-4 rounded-xl overflow-hidden"> 
        <PageTitleCard title="Data Pengiriman" />
        <hr />
        <div className='mt-5'>
          <Tabs defaultValue="todayData" className="w-full flex-col">
            <TabsList className="bg-transparent border-b-0 gap-4 w-fit">
              <TabsTrigger value="todayData" onClick={() => setActiveTab("todayData")} className={activeTab === "todayData" ? activeTabClassName : tabClassName}>
                <LucideClipboardList size={16} />
                Pengiriman Hari ini
              </TabsTrigger>
              <TabsTrigger value="searchData" onClick={() => {
                setActiveTab("searchData");
                dispatch(clearSelectedDeliveryData())
              }} className={activeTab === "searchData" ? activeTabClassName : tabClassName}>
                <LucideClipboardList size={16} />
                Cari Data Pengiriman
              </TabsTrigger>
              <TabsTrigger value="createData" onClick={() => setActiveTab("createData")} className={activeTab === "createData" ? activeTabClassName : tabClassName}>
                <PlusCircle size={16} />
                Buat Data Pengiriman
              </TabsTrigger>
            </TabsList>
            {children}
          </Tabs>
        </div>
      </div>
    </div>
  )
}

export default DailyDeliveryPageLayout;